import { render, staticRenderFns } from "./NoDataIcon.vue?vue&type=template&id=faddbc2e"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faddbc2e')) {
      api.createRecord('faddbc2e', component.options)
    } else {
      api.reload('faddbc2e', component.options)
    }
    module.hot.accept("./NoDataIcon.vue?vue&type=template&id=faddbc2e", function () {
      api.rerender('faddbc2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/NoDataIcon.vue"
export default component.exports